/**
 * Swiper 7.0.6
 * @url : https://swiperjs.com/api/
 */
// import Swiper JS
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, FreeMode, Keyboard, Mousewheel, Lazy, Autoplay } from 'swiper';

function swiperResizeCallBack(swiper) {
  swiper.slideTo(1, 0, false);
  for (let index = 0; index < swiper.$wrapperEl.length; index++) {
    const wrapper = swiper.$wrapperEl[index];
    wrapper.style.transform = '';
  }
}

export const initSwiperMobile = () => {
  const swiperSideMenu = Array.from(document.getElementsByClassName('js-swiper-mobile'));
  if (swiperSideMenu.length) {
    for (const swiper of swiperSideMenu) {
      new Swiper(swiper, {
        modules: [Mousewheel, FreeMode],
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: true,
        breakpoints: {
          768: {
            enabled: false,
          }
        },
        on: {
          resize: swiperResizeCallBack
        }
      })
    }
  }
}

export const initSwiperProductCards = () => {
  const swiperProductCards = Array.from(document.getElementsByClassName('js-swiper-product-card'));
  if (swiperProductCards.length) {
    for (const swiper of swiperProductCards) {
      const swiperInstance = new Swiper(swiper, {
        modules: [Navigation, Pagination, Keyboard, Lazy],
        allowTouchMove: false,
        slidesPerView: 1,
        lazy: {
          loadPrevNext: false,
          loadOnTransitionStart: true
        },
        loop: true,
        speed: 700,
        navigation: {
          nextEl: swiper.querySelector('.swiper-button-next'),
          prevEl: swiper.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el:  swiper.querySelector('.swiper-pagination'),
          clickable: true
        },
        keyboard: true,
        init: false
      })

      // Init only if there is 2 or more slides
      const nbSlides = swiper.getElementsByClassName('swiper-slide');
      if (nbSlides.length > 1) {
        swiperInstance.init();
      }
    }
  }
}

export const initSwiperAdCards = () => {
  const swiperAdCards = Array.from(document.getElementsByClassName('js-swiper-ad-card'));
  if (swiperAdCards.length) {
    for (const swiper of swiperAdCards) {
      let delay = parseInt(swiper.getAttribute('data-delay') || 5000);

      const swiperInstance = new Swiper(swiper, {
        modules: [Navigation, Pagination, Keyboard, Lazy, Autoplay],
        allowTouchMove: false,
        slidesPerView: 1,
        autoplay: {
          delay,
          disableOnInteraction: true,
        },
        lazy: {
          loadPrevNext: false,
          loadOnTransitionStart: true
        },
        loop: true,
        speed: 700,
        navigation: {
          nextEl: swiper.querySelector('.swiper-button-next'),
          prevEl: swiper.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el:  swiper.querySelector('.swiper-pagination'),
          clickable: true
        },
        keyboard: true,
        init: false
      })

      // Init only if there is 2 or more slides
      const nbSlides = swiper.getElementsByClassName('swiper-slide');
      if (nbSlides.length > 0) {
        swiperInstance.init();
      }
    }
  }
}

export const initSwiperProduct = () => {
  const swiperProducts = Array.from(document.getElementsByClassName('js-swiper-product'));
  if (swiperProducts.length) {
    for (const swiper of swiperProducts) {
      const swiperFractionCurrent = swiper.querySelector('.swiper-fraction-current');
      const swiperInstance = new Swiper(swiper, {
        modules: [Navigation, Pagination, Keyboard, Lazy],
        slidesPerView: 1,
        lazy: {
          loadPrevNext: false,
          loadOnTransitionStart: true
        },
        loop: true,
        speed: 700,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
        navigation: {
          nextEl: swiper.querySelector('.swiper-button-next'),
          prevEl: swiper.querySelector('.swiper-button-prev'),
        },
        keyboard: true,
        init: false,
        on: {
          slideChange: (swiper) => {
            swiperFractionCurrent.textContent = swiper.realIndex + 1;
          }
        }
      })

      // Init only if there is 2 or more slides
      const nbSlides = swiper.getElementsByClassName('swiper-slide');
      if (nbSlides.length > 1) {
        swiperInstance.init();
      }
    }
  }
}

export const initSwiperRelatedProducts = () => {
  const swiperRelatedProducts = Array.from(document.getElementsByClassName('js-swiper-related-products'));
  if (swiperRelatedProducts.length) {
    for (const swiper of swiperRelatedProducts) {
      const swiperInstance = new Swiper(swiper, {
        modules: [Navigation, Pagination, Keyboard, FreeMode],
        slidesPerView: 'auto',
        freeMode: true,
        speed: 700,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
        navigation: {
          nextEl: swiper.querySelector('.swiper-button-next--alt'),
          prevEl: swiper.querySelector('.swiper-button-prev--alt'),
        },
        keyboard: true,
        init: false,
        on: {
          resize: function(swiper) {
            swiper.pagination.update()
          }
        }
      })

      // Init only if there is 2 or more slides
      const nbSlides = swiper.getElementsByClassName('swiper-slide');
      if (nbSlides.length > 1) {
        swiperInstance.init();
      }
    }
  }
}

export const initOffersSwiper = () => {
  const offerSlider = document.querySelector('.offers-slider');
  if(offerSlider) {
    var slidesCount = offerSlider.querySelectorAll('.offers-slider__nav .swiper-slide').length;
    var swiperNav = new Swiper('.offers-slider__nav', {
      modules: [Navigation, Pagination, Keyboard, Lazy],
      loop: true,
      slidesPerView: 2,
      spaceBetween: 13,
      slideToClickedSlide: true,
      slidesPerGroup: 1,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: offerSlider.querySelector('.swiper-button-next'),
        prevEl: offerSlider.querySelector('.swiper-button-prev'),
      },
      on: {
        slideChangeTransitionStart: function(swiper) {
          if(!swiperMain) {
            return;
          }
          swiperMain.slideToLoop((swiper.realIndex) % slidesCount)
        }
      },
      breakpoints: {
        // when window width is >= 640px
        640: {
          slidesPerView: 4
        }
      }
    });
    var swiperMain = new Swiper('.offers-slider__list', {
      loop: true
    });
  }
}